<div class="n-input-group pr" [formGroup]="formGroup" *ngIf="formGroup">
  <div>
    <label for="">
      <required-indicator
        *ngIf="(isRequired && !disabled) || alwaysShowIsRequired"
      ></required-indicator
      >{{ GetLabel() }}</label
    >
  </div>
  <div>
    <textarea
      [class]="disabled ? 'disabled' : ''"
      class="n-form-control textarea-wrap display-name"
      [rows]="rows"
      placeholder="{{ GetPlaceholder() }}"
      formControlName="{{ formControlName }}"
      [style.minHeight]="getMinHeight()"
      autocompleteOff
      preventSpace
      characterCount
      [allowedChars]="characterLimit"
      (input)="onInput($event)"
      (focusout)="OnfocusOut($event)"
      [disabled]="disabled"
    ></textarea>
    <div class="char-count-container">
      <span [class]="disabled ? 'disabled-text' : ''"
        >{{ GetContentLength() }}/{{ characterLimit }}</span
      >
    </div>
    <span class="error b2 b0" *ngIf="hasError()">{{ GetError() }}</span>
  </div>
  <ng-container *ngIf="error">
    <img src="./assets/icons/error_icon.svg" alt="" class="error-icon" />
    <input-error-panel
      [errorMsg]="error"
      [class]="'errorPanel'"
    ></input-error-panel>
  </ng-container>
</div>
